export async function pdfCompletionSource(context) {
  const match = context.matchBefore(/\[#pdf\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null
  const prefix = "[#pdf "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/pdf.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()
    console.log(json)
    return {
      from: match.from + prefix.length,
      options: json["pdf"].map(img => ({
        label: img.alias,
        info: () => {
          const div = document.createElement("div")
          div.innerHTML = `<img alt="${img.alias}" src="${img.thumb}" style="max-width:200px; max-height:100px;" />`
          return div
        },
        type: "pdf"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
